module.exports = __webpack_public_path__ + "img/infoIcon.a244aeac.svg";